import React, { useContext } from "react";
import "./ProjectDetails.css";
import { ProjectContext } from "../context/ProjectContext";


const formatDate = (dateStr) => {
  if (!dateStr) return "—";

  return new Date(dateStr).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });
};

const calculateDuration = (start, end) => {
  if (!start || !end) return "—";

  const startDate = new Date(start);
  const endDate = new Date(end);

  const diffTime = endDate - startDate;
  if (diffTime <= 0) return "—";

  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 30) {
    return `${diffDays} days`;
  }

  const months = Math.floor(diffDays / 30);
  return `${months} months`;
};

/* ===== Component ===== */

const ImplementationDetails = () => {
  const { projectDetails, loadingProject } = useContext(ProjectContext);

  if (loadingProject) {
    return <div>Loading implementation details...</div>;
  }

  if (!projectDetails) return null;

  const {
    executor_names,
    registration_no,
    funder_names,
    start_year,
    end_year
  } = projectDetails;

  const duration = calculateDuration(start_year, end_year);

  return (
    <div className="card csr-card mt-4">
      {/* Header */}
      <div className="csr-card-header">
        <div className="csr-icon yellow">
          <i className="fa-solid fa-building"></i>
        </div>
        <h5 className="mb-0">Implementation Details</h5>
      </div>

      {/* Implementing NGO */}
      <div className="impl-section">
        <span className="impl-label">Implementing NGO</span>
        <div className="impl-value">
          {executor_names || "—"}
        </div>
        <div className="impl-subtext">
          Reg. No: {registration_no || "—"}
        </div>
      </div>

      <hr />

      {/* Corporate Partner */}
      <div className="impl-section">
        <span className="impl-label">Corporate Partner</span>
        <div className="impl-value">
          {funder_names || "—"}
        </div>
      </div>

      <hr />

      {/* Dates */}
      <div className="row impl-dates">
        <div className="col-6">
          <span className="impl-label">Tentative Start Date</span>
          <div className="impl-value small">
            {formatDate(start_year)}
          </div>
        </div>

        <div className="col-6">
          <span className="impl-label">Tentative End Date</span>
          <div className="impl-value small">
            {formatDate(end_year)}
          </div>
        </div>
      </div>

      {/* Duration */}
      <div className="impl-duration-box">
        <span className="impl-label">Project Duration</span>
        <div className="impl-value">
          {duration}
        </div>
      </div>
    </div>
  );
};

export default ImplementationDetails;
